import {Header} from '@/components/commons/header/Header'
import {PageCardWrapper, PageContent, PageHeading, PageWrapper} from '@/components/ui/page-atoms/PageAtoms'
import {SettingsSidebar} from '@/components/commons/settings-sidebar/SettingsSidebar'
import {Outlet} from 'react-router-dom'
import {Helmet} from 'react-helmet'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Tab, Tabs} from '@/components/ui/tab-atoms/TabAtoms'
import {routes} from '@/utilities/constants/routes'
import {StyledPageBody} from './style'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const BudgetRoute = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()

    if (!permissions?.settings?.read) {
        return <NoPermissionBox />
    }

    return (
        <PageWrapper style={{overflow: 'hidden'}}>
            <Helmet title={t('budget:meta_title')} />
            <SettingsSidebar />
            <StyledPageBody>
                <Header />
                <PageContent>
                    <PageCardWrapper style={{overflow: 'hidden'}}>
                        <PageHeading>
                            <Text render="h1" size="textXl" weight="500">
                                {t('budget:title')}
                            </Text>
                        </PageHeading>
                        <Tabs paddingX={6}>
                            <Tab to={routes.BUDGET_PROJECTS.path}>{t('budget:projects_title')}</Tab>
                            <Tab to={routes.BUDGET_EXTERNAL_COSTS.path}>{t('budget:external_costs_title')}</Tab>
                            <Tab to={routes.BUDGET_ACCESS_RATES.path}>{t('budget:access_rates_title')}</Tab>
                        </Tabs>
                        <Outlet />
                    </PageCardWrapper>
                </PageContent>
            </StyledPageBody>
        </PageWrapper>
    )
}
